// extracted by mini-css-extract-plugin
module.exports = {"header":"aeZZd","headerBundleStatsLogo":"_2l5NR","headerGithubLogo":"_39miw","headerNavigation":"DQ1qN","main":"_2G1dR","footerInfo":"_1vccB"};